<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Schedule'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <form [formGroup]="form" novalidate action="#">
        <tidy-row>
          <tidy-text
            [header]="'How do you want to book jobs?'" />
        </tidy-row>
        <tidy-row>
          <tidy-radio-button
            formControlName="option"
            [form]="form.controls.option"
            [items]="scheduleOptions"
            [submitted]="submitted"
            [errorMessage]="'Please select an option.'" />
        </tidy-row>
      </form>
    </tidy-card>

    <tidy-button
      [text]="'Next'"
      [action]="boundSubmit"
      [class]="'primary'" />

    <!-- NOTES for the future:

    -Change from radio buttons to buttons
    -Only view schedule once they have jobs or reservations

    -->
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
